var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"checkout"},[(_vm.windowSize >= 576)?_c('section',{staticClass:"pt-0 delivery-checkout"},[_c('div',{staticClass:"container"},[_c('payment')],1)]):_c('mobile-cart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }